import { ContainerLoadingStatus, ContainerStatusEnum } from "@gtpl/shared-models/common-models";
import { SaleOrderDropDownDto, SODto } from '@gtpl/shared-models/sale-management';
import { ApiProperty } from "@nestjs/swagger";
export class ContainerStatusInfo {
    @ApiProperty()
    containerNo:string;
    @ApiProperty()
    containerStatus:ContainerStatusEnum;
    @ApiProperty()
    saleOrder:SaleOrderDropDownDto;
    @ApiProperty()
    loadingStatus:ContainerLoadingStatus;
    @ApiProperty()
    containerId?:number;

    /**
     * 
     * @param containerNo 
     * @param containerStatus 
     * @param saleOrder 
     * @param loadingStatus 
     * @param containerId 
     */
    constructor(containerNo:string, containerStatus:ContainerStatusEnum, saleOrder:SaleOrderDropDownDto, loadingStatus:ContainerLoadingStatus,containerId?:number) {
        this.containerNo = containerNo;
        this.containerStatus = containerStatus;
        this.saleOrder = saleOrder;     
        this.loadingStatus = loadingStatus;     
        this.containerId = containerId;     
    }
    
}